import Image from 'next/image';
import type React from 'react';

import { AdvertisementPublicData } from '@cineamo/api/helpers/advertisement-helper';

import AdvertisementCloseButton from './AdvertisementCloseButton';
import { AdvertisementRenderLink, DefaultAdvertisementLink, resolveAdvertisementLinkTarget } from './link';

type BannerAdvertisementProps = {
    onClose: () => void;
    onClick: () => void;
    advertisement: AdvertisementPublicData;
    // Defaults to a plain `<a>` — hosts with locale-aware, typed routing must inject their own.
    renderLink?: AdvertisementRenderLink;
};

const BannerAdvertisement: React.FC<BannerAdvertisementProps> = ({
    onClose,
    onClick,
    advertisement,
    renderLink = DefaultAdvertisementLink
}) => {
    if (!advertisement.topBannerImageUrl && !advertisement.topBannerDesktopImageUrl) {
        return null;
    }

    const target = resolveAdvertisementLinkTarget(advertisement);
    const adName = advertisement.contentName ?? advertisement.advertiserName ?? '';

    const banner = (
        <picture>
            <source
                srcSet={advertisement.topBannerImageUrl}
                media="(max-width: 1024px)"
            />
            <Image
                src={advertisement.topBannerDesktopImageUrl ?? advertisement.topBannerImageUrl}
                alt={`${adName} Advertisement Banner`}
                className="w-full h-auto"
                width={1920}
                height={120}
            />
        </picture>
    );

    return (
        <div className="relative">
            {renderLink({ target, onClick, children: banner })}

            <AdvertisementCloseButton
                className="absolute top-4 right-4"
                onClose={onClose}
            />
        </div>
    );
};

export default BannerAdvertisement;
